var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileError = function SvgFileError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.11 8.847h28.84c2.432 0 4.38 1.98 4.38 4.4v26.404a4.65 4.65 0 0 1-.503 2.068l-3.876-3.895V17.648H26.87zm29.914 42.487-7.27-7.283H11.913c-2.431 0-4.38-1.98-4.38-4.4V13.248c0-.748.175-1.452.503-2.068L4.665 7.77l3.088-3.103 43.36 43.564zM36.374 39.65l-21.9-22.002h-2.561v22.003z"
  })));
};
export default SvgFileError;